import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import TrainCard from "./TrainCard";
import { useTranslation } from "../i18n/useTranslation";

const TrainBoard = ({ sections = [], hideTrainProgress = false }) => {
  const { t } = useTranslation();
  const populatedSections = sections.filter(
    (section) => section.online.length || section.offline.length
  );

  if (!populatedSections.length) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ py: 4, textAlign: "center" }}>
        {t("trainBoard.empty")}
      </Typography>
    );
  }

  return (
    <Stack spacing={3}>
      {populatedSections.map((section) => {
        const orderedTrains = [...section.online, ...section.offline];

        return (
          <Stack key={section.routeId} spacing={1.5}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              {section.routeName}
            </Typography>
            <Grid container spacing={2.5}>
              {orderedTrains.map((train) => (
                <Grid item xs={12} md={6} lg={4} key={`${train.id}-${train.stationReference}`}>
                  <TrainCard train={train} hideProgress={hideTrainProgress} />
                </Grid>
              ))}
            </Grid>
          </Stack>
        );
      })}
    </Stack>
  );
};

export default TrainBoard;
